
const RadniNalog = function(DS) {
    return DS.defineResource({
        name: 'RadniNalog',
        endpoint: '/radniNalozi'
    });
};

RadniNalog.$inject = ['DS'];


const PlanRada = function(DS) {
    return DS.defineResource({
        name: 'PlanRada',
        endpoint: '/planRada'
    });
};

PlanRada.$inject = ['DS'];

export {PlanRada};
export {RadniNalog};



// WEBPACK FOOTER //
// ./app/models/radniNalog.js